import { configureStore } from "@reduxjs/toolkit";
import managementReducer from "./mgmtCo/managementSlice";
import selectedManagementReducer from "./mgmtCo/selectedManagementSlice";
import paginationReducer from "./mgmtCo/paginationSlice";
import loadingReducer from "./loading/loadingSlice";
import errorReducer from "./error/errorSlice";
import notificationsSlice from "./notifications/notificationsSlice";
import navHeightSlice from "./navbar/navHeightSlice";
import contactsReducer from "./mgmtCo/contactsSlice";
import managementCustomerReducer from "./mgmtCo/managementCustomerSlice";
import selectedManagementContactReducer from "./mgmtCo/selectedContactSlice";
import selectedManagementCustomerReducer from "./mgmtCo/selectedCustomerSlice";
import agencyReducer from "../pages/inspections/components/AgencyList/agencySlice";

import customersReducer from "./customers/customerSlice";
import customerPaginationReducer from "./customers/customerPaginationSlice";
import selectedCustomerReducer from "./customers/selectedCustomerSlice";
import customerContactsReducer from "./customers/customerContactsSlice";
import selectedCustomerContactReducer from "./customers/selectedCustomerContactSlice";
import customerBuildingReducer from "./customers/customerBuildingSlice";
import selectedCustomerBuildingReducer from "./customers/selectedCustomerBuildingSlice";

import buildingsReducer from "./buildings/buildingsSlice";
import buildingsPaginationReducer from "./buildings/buildingsPaginationSlice";
import selectedBuildingReducer from "./buildings/selectedBuildingSlice";
import buildingContactsReducer from "./buildings/buildingContactsSlice";
import selectedBuildingContactReducer from "./buildings/selectedBuildingContactSlice";
import selectedBuildingDevicesReducer from "./buildings/selectedBuildingDevicesSlice";
import buildingDevicesReducer from "./buildings/buildingDevicesSlice";

export default configureStore({
  reducer: {
    // site wide loading/error states
    loading: loadingReducer,
    error: errorReducer,
    notifications: notificationsSlice,
    navHeight: navHeightSlice,

    // management companies
    management: managementReducer,
    selectedManagement: selectedManagementReducer,
    managementContacts: contactsReducer,
    selectedManagementContact: selectedManagementContactReducer,
    managementCustomers: managementCustomerReducer,
    selectedManagementCustomer: selectedManagementCustomerReducer,
    pagination: paginationReducer,

    // customers
    customers: customersReducer,
    customerPagination: customerPaginationReducer,
    selectedCustomer: selectedCustomerReducer,
    customerContacts: customerContactsReducer,
    selectedCustomerContact: selectedCustomerContactReducer,
    customerBuildings: customerBuildingReducer,
    selectedCustomerBuilding: selectedCustomerBuildingReducer,

    // buildings
    buildings: buildingsReducer,
    buildingsPagination: buildingsPaginationReducer,
    selectedBuilding: selectedBuildingReducer,
    buildingContacts: buildingContactsReducer,
    selectedBuildingContact: selectedBuildingContactReducer,
    selectedBuildingDevices: selectedBuildingDevicesReducer,
    buildingDevices: buildingDevicesReducer,

    agency: agencyReducer,
  },
});
